module.exports = "/packs/images/our-technology/hero@2x-76f515828b0f34d2e9cd699a85090969.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/our-technology/hero@2x.jpg
// module id = 1785
// module chunks = 0